window.garment = window.garment || {};

// Initilize Garment
garment.init = function(){
  
  garment.is_mobile = ($(window).width() < 768);
  
  garment.$ = $('.main-content');
  
  // watch scroll
  if(garment.is_mobile) garment.watchScrollBuyButton();
  
//   $('#garment-select-btn-mobile').sticky();
  
}


garment.resizeModal = function(){
  garment.$.find('.modal').height($(document).height());
}

garment.watchScrollBuyButton = function(){

  	var $bt = $('#garment-select-btn');
    var $bt2 = $('#garment-select-btn-mobile');
    var vp = $(window).height();

    $(window).scroll(
      function(){
        
        var h = $('#garment-select-btn').offset().top;

        var st = $('body').scrollTop();
        var x = vp+st-h+10;
        
//         $('wil').text((vp+st)+' -- '+h);
        
        if(x>0){
          if(!$bt2.hasClass('hide')){
            $bt2.addClass('hide').removeClass('show');
          }
        }else{
          if($bt2.hasClass('hide')){
            $bt2.removeClass('hide').addClass('show');
          }
          
        }
      }
    );
  
  }



$(garment.init);


  
  var garments = {};
  var ajax_items = [];
  var ajax_total_items = 0;
  var ajax_ok_items = 0;
  var current_garment_id = 0;
  var is_mobile = false;
  
  var defaults = {
    style: '',
    color: ''
  }
  
  
  
  
  $(document).ready(
    function(){
      
      
      $('.modal-close, .modal-close2').click(
    function(){
      $(this).parents('.modal').fadeOut();
      return false;
    }
  );

  $('#garment-select-btn, #garment-select-btn-mobile').click(
    function(){
      addToCart();
      return false;
    }
  );
  
  
 $('ul.garment-thumbs a').click(
   function(e){
     garmentThumbsClick($(this), e);
     return false;
   }
 );

 $('select[name=styles-menu]').change(
   function(e){
     
     var style_id = $(this).val();
     var $garment = $('.garments').find('li[data-product-id='+style_id+']');
     
     $('.garment-featured-image-mobile').find('li').hide();
     $('.garment-featured-image-mobile').find('li[data-style-id='+style_id+']').show();
     

     $('.garments').find('li').hide().removeClass('current');
   	$('.garments').find('li[data-product-id='+$(this).val()+']').show().addClass('current');
     
     // Hide & show product photos
     $garment.find('.garment-product-photos').find('a').hide();
//      $garment.find('.garment-product-photos').find('a').first().show();
     
     refreshGarmentPreselectColors(style_id, e);
     
//      setSizeText(style_id);
     
     if(e.originalEvent != undefined) SEOHash();
     
   }
 );
  
  // Add another style or color
  $('a[href=#add-style]').click(
    function(){

      var $tr = $('.garment-checkout-form').find('tbody').find('tr').first().clone();
      $tr.addClass('clone');
      applySelectEvents($tr);
      $tr.find('span.price').html('...');
      $tr.insertAfter($('.garment-checkout-form').find('tbody').find('tr').last());
      
      var t = $tr.offset().top;
      $("html, body").animate({ scrollTop: t });
      
      
      refreshDropDowns($tr, $tr.find('select[name=style]').val())
      
      // trigger size chart popup
      $tr.find('.size-text').click(
        function(){
          modalItemSizeTextClick($(this));
        }
      );
      
      refreshItemCounters();
      
      garment.resizeModal();
      
      return false;
      
    }
  );
  
      
//       $('.color, .garment-thumbs a').tooltip({trigger : 'hover'});
      
      $('.garment-image a').each(
        function(){
          $(this).zoom({on: 'click', url: $(this).attr('data-url')});
        }
      );
      
      $('.garment-featured-image-mobile a').each(
        function(){
          $(this).zoom({on: 'click', url: $(this).attr('data-url')});
        }
      );
      
      reorderStyles();
      
      showPlayerPhotoIfExists();
      
      is_mobile = ($(window).width() < 768);
      
      garmentsInit();
      
      if(is_mobile){
//         $('#garment-select-btn').sticky({bottomSpacing});
        $('.modal').height($(document).height());
        
        
      }
      
      
      

  
  
  // Product Sidebar Nav
  
  $('.garment-sidebar-navigation').find('a[href=#shipping-returns]').click(
    function(){
      shippingReturns();
      return false;
    }
  );
  
  $('.garment-sidebar-navigation').find('a[href=#other-fine-products]').click(
      function(){

        scrollToH2($(this));
        return false;
      }
   	);
    
  
  $('a[href="#sizes-available"]').click(
      function(){
		availableSizes(getCurrentGarmentStyleId());
        return false;
        
        
        
//          OLD STUFF...
        
        var txt = $(this).text();
        
        var $h2 = $('.garments-left').find('.current').find('h2:contains("'+txt+'")');
		var h = $h2.height();
        var t = $h2.offset().top-h-20;
        
        $("html, body").animate({ scrollTop: t });
        return false;
        
      }
   	);
    

	  	var w = 0; jQuery('.product-single__thumbnails').find('li').each(function(){ w+=jQuery(this).outerWidth() });
    jQuery('.product-single__thumbnails').width(w);
  
  // Check for sizes before submit
  $('.garment-checkout-form').submit(
    function(){
      
//       ga('send', 'event', 'Garment Collection', 'Ckeckout Counter', getCountdownText());
      
      var size_error = false;
      var color_error = false;
      var id_error = false;
      var error = false;
      var size_error_count=0;

      $(this).find('select[name=size]').each(
        function(i,o){
          if($(o).val() == '...'){
            
            if(++size_error_count==1){
              	var t = jQuery(this).closest('tr').offset().top;
                $("html, body").animate({ scrollTop: t });
            }
            
            size_error = true;
            redAlert($(o));
          }
        }
      );
      
      $(this).find('input[name=color]').each(
        function(i,o){
          if($(o).val() == '') color_error = true;
        }
      );
      
      
      $(this).find('input[name="id"]').each(
        function(i,o){
          if($(o).val() == '') id_error = true;
        }
      );
      
      
      
      
      if(size_error){
        $(this).find('.error-message').text('Please select a size.').fadeIn();
        return false;
      }else if(color_error){
      	$(this).find('.error-message').text('Please select a color.').fadeIn();
        return false;
      }else if(id_error){
      	$(this).find('.error-message').text('ID error.').fadeIn();
        return false;
      }
      
      error = id_error || size_error;
      
      if(!error){
//         $('.modal').fadeOut();
        $(this).find('.error-message').hide();
      }
      
      

      // Ok to submit
      
      adjustCartDrawerHeight();
      
      $('.btn.garment-checkout-btn').attr('disabled', true);
      
      
      $(this).find('input[name="id"]').each(
        function(i,o){
          var qty = $(this).closest('tr').find('select[name=qty]').val();
          saveAjaxItem($(this).val(), qty);
        }
      );
      
      addNextAjaxItem(
        function(){
//         	console.log('Im finished!');
          	$('.modal').fadeOut();
          	timber.RightDrawer.open();
          	ajaxCart.itemAddedCallback();
          	$('.btn.garment-checkout-btn').attr('disabled', false);
        }
      );
      
      return false;
      
    }
  );
      
      
      
    }
  );
  
  
  
  function setVariant(style_id){
    
    var $style_modal = $('#garment-options-'+style_id);
    var size = $style_modal.find('select:eq(2)').val();
    var color = $style_modal.find('select:eq(3)').val();
    var style = $style_modal.find('select[name=style]').val();
    var text = style + " / " + color + " / " + size;
    
    var $variant_option = $style_modal.find('select').find('option:contains('+text+')');
    
    
  }
  
  
  function saveAjaxItem(id, qty){
    ajax_items.push([id, qty]);
  }
  
  
//   Upon STYLE select, we need to refresh dropdowns (SIZE, COLOR) for a given $product_id in a $style_modal
  function refreshDropDowns($style_modal, product_id){
    
    $data = $('#data-dropdowns-'+product_id);
    
	$style_modal.find('[name=size]').replaceWith($data.find('[name=size]').clone());
//     $style_modal.find('[name=color]').replaceWith($data.find('[name=color]').clone());
    
    $style_modal.find('.garment-colors').replaceWith($data.find('.garment-colors').clone());    
    $style_modal.find('span.price').html('...');
    
//     $style_modal.find('[name=size]').change(function(){ optionChange($(this)) });
//     $style_modal.find('[name=color]').change(function(){ optionChange($(this)) });
    
    applySelectEvents($style_modal);
    
    
    // Set defaults
    $style_modal.find('.garment-colors').find('a[data-color="'+defaults.color+'"]').click();
    $style_modal.find('.selected-color').text(defaults.color);
    
    $style_modal.find('.size-text').text(getSizeText(product_id));
    
  }
  
  
  // Triggered by "Add To Cart" button
  function addToCart(){
    
//     var style_id = $('select[name=styles-menu]').val();
    var style_id = getCurrentGarmentStyleId();
    
    var $style_modal = $('#modal-cart');
    var $tr = $style_modal.find('tbody').find('tr').first();
    
 
    // Sort ddown options
    sortDropdown($tr.find('select[name=style]'));
    
    $style_modal.find('.error-message').show();
    
    // Remove previous TR's
    $style_modal.find('.clone').remove();
    
    
    if(is_mobile) $('.modal-container').css('top', $('body').scrollTop()+10);
    
    $style_modal.fadeIn();
    
    var selected_style = getCurrentGarmentStyleName();

    
//     $('select[name=style] option').filter(function () { return $(this).text() == selected_style; }).attr('selected', true);
    $tr.find('select[name=style]').find('option:contains('+selected_style+')').attr('selected', true);
    $tr.first().find('select[name=style]').find('option:contains("'+selected_style+'")').text(selected_style)
    
    
    
    refreshDropDowns($tr, style_id);
    
    if($style_modal.hasClass('binded')) return;
    $style_modal.addClass('binded');  
    

    $tr.find('select[name=style]').change(
      function(){
        refreshDropDowns($tr, $(this).val());
        optionChange($(this));
      }
    );
    
    
    applySelectEvents($tr);
//     setDropdowns($tr);
    
    // trigger size chart popup
      $tr.find('.size-text').click(
        function(){
          modalItemSizeTextClick($(this));
        }
      );
    
	refreshItemCounters();
    
    garment.resizeModal();
    
    
    
  }
  
  
  function setDropdowns($tr){
    $tr.find('select').dropdown();
  }
  
  
  function applySelectEvents($tr){

    $tr.find('a.color').click(
      function(){
        $tr.find('a.color.selected').removeClass('selected');
        $(this).addClass('selected');
      	var color = $(this).attr('data-color');
        $tr.find('.selected-color').text(color);
        $tr.find('[name=color]').val(color);
        optionChange($(this));
        return false;
      }
      
    );
    
    $tr.find('a[href=#remove]').unbind('click');
    $tr.find('a[href=#remove]').click(
      function(){
        removeItem($(this).closest('tr'));
        refreshItemCounters();
        
        return false;
      }
   	);
    
    $tr.find('select, input').change(
      function(){
        
        setVariantId($(this).closest('tr'));
        
        if($(this).attr('name') == 'style') refreshDropDowns($(this).closest('tr'), $(this).val());
          
      }
    );
  }
  
  
  
  function removeItem($tr){
    if($('.table-variants tbody tr').size() == 1){
      	$('#modal-cart').fadeOut();
    	return;
    }
    
    $tr.remove();
  }
  
  
  function optionChange($select){
    
    var $tr = $select.closest('tr');

    var $id = $tr.find('[name="id"]');
    var size = $tr.find('[name=size]').val();
    var qty = $tr.find('[name=qty]').val();
    var color = $tr.find('[name=color]').val();
    var style = $tr.find('[name=style] option:selected').text();
    var text = style + " / " + color + " / " + size;
    
    var $variant_option = $('select').find('option:contains('+text+')');

    
    var price = ($variant_option.attr('data-price'));
    if(price){
      $tr.find('span.price').html(qty*price);
      fhl.hideColorPriceWarning();
    }
    
    $id.val($variant_option.val());
    
    
  }
  
  
  function setVariantId($tr){

    var $id = $tr.find('[name="id"]');
    var size = $tr.find('[name=size]').val();
    var color = $tr.find('[name=color]').val();
    var qty = $tr.find('[name=qty]').val();
    var style = $tr.find('[name=style] option:selected').text();
    var text = style + " / " + color + " / " + size;
    
    var $variant_option = $('select').find('option:contains('+text+')');
    
    var price = ($variant_option.attr('data-price'));
    if(price){
      $tr.find('span.price').html(qty*price);
      fhl.hideColorPriceWarning();
    }
    
    $id.val($variant_option.val());
    
  }
  
  
  
  function refreshGarmentPreselectColors(style_id, e){
    $('.garment-selector').find('.pre-select-colors').find('li').hide();
    $('.garment-selector').find('.pre-select-colors').find('li.style-'+style_id).show();
    
    if(e != undefined && e.originalEvent != undefined) $('.garment-selector').find('.pre-select-colors').find('li.style-'+style_id).find('a:first').click();
    
  }
  
  
  
  function addNextAjaxItem(callback){
    
    if(ajax_items.length < 1) return;
    
    item = ajax_items.pop();
    
    // Cookie counter for this item
    cookieCounter(item[0]);
    
    ajaxItem(item[0], item[1],
      	function(){
      
      	  if(ajax_items.length > 0){
      		addNextAjaxItem(callback);
          }else{
            if(callback!=null) callback();
          }
		}
	);
    
  }
  
  
  
  function ajaxItem(variant_id, quantity, callback) {
    ajax_total_items++;
    var quantity = quantity || 1;
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      //data: 'quantity=' + quantity + '&id=' + variant_id + "&properties[countdown]="+getCountdownText(),
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      success: function(line_item) { if(callback) callback() },
      error: function(xhr, status) { alert('ERROR'); console.log(xhr); console.log(status);  }
    };
    
    
    $.ajax(params);
  }
  
  function ajaxOk(){
    return ++ajax_ok_items == ajax_total_items;
  }
  
  
  
  function allItemsAdded(){
    
    if(ajax_total_items == 0) return;
    
    ajax_total_items = 0;
    ajax_ok_items = 0;
  
  	ajaxCart.load();
    
  }
  
  
  
  function preselectColor(color){
    
//     console.log('Preselecting color...'+ color);

    defaults.color = color;
    
//     var style = $('.garment-selector').find('[name=styles-menu] option:selected').text();
    var style = getCurrentGarmentStyleName();
    var text = style + " / " + color + " / ";
	
    checkVariantImage(text);
    
  }
  
  
  
  function garmentsInit(){
    
    
    

    
    
    // Show style thumbs
    $('.garment-thumbs').show();
    if(!is_mobile) $('.garment-image').show();
    
    initData();
    
    // Set the initial size text
//     setSizeText(garments.current_style)
    
    $('#garment-size-text').click(
      function(){
      	availableSizes($('select[name=styles-menu]').val())
      }
    );
    
    
    $('.garment-selector').find('.pre-select-colors').find('a').click(
      function(e){

        $('.garment-selector').find('.pre-select-colors').find('a.selected').removeClass('selected');
        $(this).addClass('selected');
        var color = $(this).attr('data-color');
        
        preselectColor(color);
        selectedColorName($(this).closest('li'), color);
        
        if(e.originalEvent != undefined) SEOHash();
        return false;
      }
    );
    
    $('#garment-gender-menu').find('a').click(
      function(){
        clickGender($(this).attr('href'));
      	return false;
      }
    );
    
    
    
    
    if(checkSEOHash()){
    }else{
      $('.garment-selector').find('.pre-select-colors').find('li:first').find('a:first').click();
      $('#garment-gender-menu').find('a[href="men"]').click();
    }
    
    
    
    
    
    cropMobileMainImage();
    
    
    
    jQuery('#garment-select-btn').on("tap", function(){
      $(this).hide();}
    );
    
    
    
    
    
    
    
  }
  
  
  function setGender(gender){
    
    $('.garment-thumbs').find('.disabled').removeClass('disabled');
    
    $('.garment-thumbs').find('a').each(
      function(i,o){
        var has_gender = $(this).attr('data-gender').split('|').indexOf(gender)>-1;
        if(!has_gender) $(this).parent().addClass('disabled');
      }
    );
    
    // automatically click first visible thumb
    $('.garment-thumbs').find('li:visible').find('a').first().click();
    
    // automatically click first visible color
    $('.pre-select-colors').find('li:visible').find('a').first().click();
    
  }
  
  
  
  function checkErrors(){
  }
  
  
  function checkVariantImage(s){
    
    var image_id = 0;
  
    for(var i in variant_images){
      if(i.indexOf(s) == 0){
        image_id = (variant_images[i]);
        break;
      }
    }
    
    

    
    
    
    
    if(image_id != 0){
      if($('.garment-product-thumbs').find('a[data-image-id='+image_id+']').size() == 0){
        // Do some
        console.log('error @ checkVariantImage()');
      }else{
        var $thumb = $('.garment-product-thumbs').find('a[data-image-id='+image_id+']'); // the assocaited thumb
        
        $('.garment-product-thumbs').find('a[data-image-id='+image_id+']').click();
        
        
        $('#ProductPhoto-'+image_id).parent().find('a').hide();
        $('#ProductPhoto-'+image_id).show();
        

        
        // refresh mobil featured image
        setMobileFeaturedImage(getCurrentGarmentStyleId(), $thumb.attr('data-image-grande'));
      }
      
    }
    
  }
  
  
  function showImageFromID(id){
    $('#ProductPhoto-'+id).show();
  }
  
  
  function getImageID(s){
    
    var image_id = 0
    
  	for(var i in variant_images){
      if(i.indexOf(s) == 0){
        image_id = (variant_images[i]);
        break;
      }
    }
    
    
    return image_id;
    
  }
  
  
  
  function openModal(selector){
    
    
    var $modal = $(selector);
    if(is_mobile) $('.modal-container').css('top', $('body').scrollTop()+10);
    
    $modal.fadeIn(
      function(){
        $modal.height($(document).height());
      }
    );

  }
  
  
  
  // 
  function clickGarmentColor(style_id, color){
  
    $('.garment-selector').find('.pre-select-colors').find('a.selected').removeClass('selected');
    var $a = $('.garment-colors.style-'+style_id).find('a[data-color="'+color+'"]');
    
    $a.addClass('selected');
    
    preselectColor(color);
    selectedColorName($a.closest('li'), color);
  
  }
  
  
  function clickGarmentColorHandle(style_id, color){
  
    $('.garment-selector').find('.pre-select-colors').find('a.selected').removeClass('selected');
    var $a = $('.garment-colors.style-'+style_id).find('a[data-color-handle="'+color+'"]');
    $a.click();
  
  }
  
  
  
  function availableSizes(garment_id){
    openModal('#available-sizes-'+garment_id);
  }
  
  function shippingReturns(){
    openModal('.shipping-returns');
  }
  
  
  function setSizeText(style_id){
    var size_text = garments.products[style_id].size_text;
// 	$('#garment-size-text').text(size_text);
  }
  
  function getSizeText(style_id){
    return garments.products[style_id].size_text;
  }
  
  
  
  function SEOHash(){
    
    color = defaults.color;
    var style = getCurrentGarmentStyleName();
  
    var seo_hash = style+'/'+color;
    seo_hash = seo_hash.replace(new RegExp(' ', 'g'), '-').toLowerCase();
    window.location.replace('#'+seo_hash);
    return false;
  
  }
  
  
  
  function checkSEOHash(){

    if(location.hash == '') return false;
  
    var hash_data = location.hash.replace('#', '').replace("'", '').split('/');
    
    var style = hash_data[0];
    var color = hash_data[1];


    if(style.toLowerCase().indexOf('women')>-1){
      var gender="women";
    }else if(style.toLowerCase().indexOf('kids')>-1){
      var gender="kids";
    }else{
      var gender="men";
    }
    

    var style_id = $('.garment-selector').find('[name=styles-menu] option[data-style-handle="'+style+'"]').val();
    
    
    // If not color...
    if(style != '' && color == ''){
      color = $('.pre-select-colors li.garment-colors.style-'+style_id).find('.color-wrapper a').attr('data-color-handle');
    }
    
    // Check if HASH contains two tokens
    if(style == undefined || color == undefined) return false;
    

    // 	$('.garment-selector').find('[name=styles-menu] option:contains("'+style+'")').prop('selected', true);
//     $('.garment-selector').find('.garment-thumbs a[data-style-name= "'+style+'"]').addClass('selected').click();


//     var style_id = $('.garment-selector').find('[name=styles-menu]').val();
//     var style_id = getCurrentGarmentStyleId()
    
    clickGender(gender);
    clickStyle(style_id);
    clickGarmentColorHandle(style_id, color);
    
    var text = style + " / " + color + " / ";

    checkVariantImage(text);
    
//     $('.garment-product-photos').fadeOut();
    
//     refreshGarmentPreselectColors(style_id);
//     $('.garment-selector').find('[name=styles-menu]').change();
    
//     preselectColor(color);
    
//     console.log('>>>>');
//     console.log(style);
//     console.log($('a[data-style-name="'+style+'"]'));
    
//     $('a[data-style-name="'+style+'"]').click();
    
//     $('#garment-gender-menu').find('a[href="'+gender+'"]').click();

//     showImageFromID(getImageID(style + " / " + color + " / "));
    
    return true;
  
  }
  
  
  // 
  function modalItemSizeTextClick($a){
    var style = $a.parents('tr').find('select[name=style]').val();
    availableSizes(style);
  }
  
  
  
  function scrollToH2($a){
  
  	var txt = $a.text();
        
    var $h2 = $('h2:contains("'+txt+'")');
    var h = $h2.height();
    var t = $h2.offset().top-h-20;

    $("html, body").animate({ scrollTop: t });
    return false;
  
  }
  
  
  
  

  
  
  function garmentThumbsClick($a, e){
    
    
    
    $('.garment-thumbs').find('.selected').removeClass('selected');
    $a.addClass('selected');
     
     var style_id = $a.attr('href');
    
    // Show style info
    $('.style-info li').hide();
    $('#style-info-'+style_id).show();

    var $option = $('select[name=styles-menu]').find('option[value='+style_id+']');
    
     var $garment = $('.garments').find('li[data-product-id='+style_id+']');
     
     $('.garment-featured-image-mobile').find('li').hide();
     $('.garment-featured-image-mobile').find('li[data-style-id='+style_id+']').show();
     

     $('.garments').find('li').hide().removeClass('current');
   	$('.garments > li[data-product-id='+style_id+']').show().addClass('current');
     
     // Hide & show product photos
     $garment.find('.garment-product-photos').find('a').hide();
     $garment.find('.garment-product-photos').find('a').first().show();
    
    showPriceRange(style_id);
     
     refreshGarmentPreselectColors(style_id, e);
     
//      setSizeText(style_id);
     
     if(e.originalEvent != undefined) SEOHash();
     
   }
  
  
  function getCurrentGarmentStyleId(){
  	var $a = $('.garment-thumbs').find('.selected');
    return $a.attr('href');
  }
  
  function getCurrentGarmentStyleName(){
  	var $a = $('.garment-thumbs').find('.selected');
    return $a.attr('data-style-name');
  }
  
  
  function showPriceRange(product_id){
    
    $('.price-range li').hide();
    $('.price-range').find('li[data-product-id="'+product_id+'"]').show();
    
  }
  
  
  function setMobileFeaturedImage(style_id, image_src){
    $('.garment-featured-image-mobile').find('li[data-style-id='+style_id+']').find('img').attr('src', image_src);
    
  }
  
  
  
  // Crop mobile main image container to sqaured proportions
  function cropMobileMainImage(){
  	var $container = $('.garment-featured-image-mobile');
	$container.height($container.width());
    $container.css({'overflow':'hidden'});
  }
  

  function cookieCounter(variant_id){
  	return;
    
    
    
  	var cart_counters = getCookie('cart_counters');
    
    if(cart_counters == ''){
      cart_counters=[];
    }else{
      cart_counters=cart_counters.split(',');
    }
    
    cart_counters.push([variant_id, getCountdownText()].join('|'))
    
    setCookie('cart_counters', cart_counters.join(','), 30);
  
  }
  
  
  function sendCountersToGA(){
    return;
    
    
    
	var cart_counters = getCookie('cart_counters').split(',');
    
    for(i=0; i<cart_counters.length; i++){
    	ga('send', 'event', 'Orders', 'Purchase Counter', cart_counters[i]);
    }
    
    setCookie('cart_counters', '', -1);
    
    
    
  }
  
  
  function refreshItemCounters(){
  
  var n=0;
var t=$('.table-variants tbody tr').size()-0;
$('.table-variants tbody tr').each(
function(i,o){
var $counter = ($(o).find('.item-counter'));
if($counter) $counter.html((++n)+' of '+t);
}
);
  }
  
  
  function adjustCartDrawerHeight(){
    if(jQuery(window).width()>768) return;
    
    
    $("#CartDrawer").animate({ scrollTop: $(document).height() }, 1000);
    
    return;
	var A = jQuery('.ajaxcart__footer').outerHeight();
	var B = jQuery('#CartContainer').offset().top;
	var C = jQuery(window).height();
    var x = C-(A+B);
    alert(x);
    jQuery('.ajaxcart__inner').height(x);
  }
  
  
  function redAlert($select){
  
    //Color row background in HSL space (easier to manipulate fading)
    var $td = $select.parents('td');
    $td.css('backgroundColor','hsl(0,100%,50%');

    var d = 10;
    for(var i=50; i<=100; i=i+0.1){ //i represents the lightness
        d  += 1;
        (function(ii,dd){
            setTimeout(function(){
                $td.css('backgroundColor','hsl(0,100%,'+ii+'%)'); 
            }, dd);    
        })(i,d);
    }
  
  }
  
  
  function sortDropdown($dropdown){
    
    var options = $dropdown.find('option');
    $dropdown.addClass('sorted');
    var arr = options.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
    arr.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
    options.each(function(i, o) {
      o.value = arr[i].v;
      $(o).text(arr[i].t);
    });
    
    $dropdown.change();
  
  }
  
  
  
  
  function clickGender(gender){
    
    var $a = $('#garment-gender-menu').find('a[href="'+gender+'"]');

    $('#garment-gender-menu').find('a.selected').removeClass('selected');

    $a.addClass('selected');

    setGender(gender);
    
  }
  
  
  function clickStyle(style){
    
    var $a = $('.garment-thumbs').find('a[href="'+style+'"]');
    $a.click();
    
  }
  
  
  function clickColor(color){}
  
  
  function reorderStyles(){
  
      order_map = ['Men\'s Premium T-Shirt', 'Men\'s V-Neck', 'Men\'s Tank Top', 'Men\'s Cotton T-Shirt', 'Men\'s Baseball T-Shirt', 'Men\'s Long Sleeve', 'Men\'s Crew Neck', 'Men\'s Hoodie', 'Men\'s Lace Hoodie', 'Men\'s Zip Hoodie', 'Kids Onesie', 'Kids T-Shirt', 'Kids Youth Hoodie', 'Women\'s Scoop Neck', 'Women\'s V-Neck', 'Women\'s Tank Top', 'Women\'s Maniac Sweatshirt', 'Women\'s Hoodie'];

    
      for(var i=0; i<order_map.length; i++){
        var o = order_map[i];
        var $a = $('.garment-thumbs li a[data-style-name="'+o+'"]');
        if($a.length>0){
            var $li = $a.parent();
            var $li2 = $li.detach();
          
          if($('.garment-thumbs li').eq(i).size()==0){
            $('.garment-thumbs').append($li2);
          }else{
            $('.garment-thumbs li').eq(i).after($li2);
          }

          
        }
      }
    
    
    
    $('.garment-thumbs li a').first().click();

    

  }
  
  
  
  
  function selectedColorName($li, color_name){
    $li.find('.selected-color-name').text(color_name);
  }
  
  
